const QuestionCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      fill="var(--question-circle-fill)"
      fillRule="evenodd"
      d="M11.754 3.5a8.254 8.254 0 1 0 0 16.508 8.254 8.254 0 0 0 0-16.508ZM2 11.754C2 6.367 6.367 2 11.754 2s9.753 4.367 9.753 9.754-4.366 9.754-9.753 9.754C6.367 21.508 2 17.14 2 11.754Zm7.004-2.167a2.75 2.75 0 1 1 5.5 0c0 1.194-.778 1.824-1.32 2.189-.458.308-.68.555-.68.978v.25a.75.75 0 0 1-1.5 0v-.25c0-1.211.788-1.85 1.342-2.222.446-.301.658-.54.658-.945a1.25 1.25 0 1 0-2.5 0 .75.75 0 1 1-1.5 0Zm2.745 7.412a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      clipRule="evenodd"
    />
  </svg>
)
export { QuestionCircle }
